import axios from 'axios'


export default axios.create({
    baseURL: `${process.env.REACT_APP_PROVIDER2}`,
    headers: {
    
        'platform': "agent",

        'Content-type': 'application/json'
    }
}) 

